import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import ErrorBoundary from './components/ErrorBoundary';
import AuthInit from './components/AuthInit';
import { PermissionProvider } from './context/PermissionContext';
import { SidebarRailProvider } from './context/SidebarRailContext';
import QuickNotesDock from './components/quickNotes/QuickNotesDock';
import { store } from './store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AppThemeProvider } from './context/AppThemeContext';
import { applyThemeCssVariables, getStoredThemeId, getThemePresetById } from './theme/themePresets';

applyThemeCssVariables(getThemePresetById(getStoredThemeId()));

// Ignore a known browser/devtools ResizeObserver noise that can break the React overlay.
const isResizeObserverNoise = (message = '') =>
  typeof message === 'string' &&
  (message.includes('ResizeObserver loop completed with undelivered notifications') ||
    message.includes('ResizeObserver loop limit exceeded'));

window.addEventListener('error', (event) => {
  if (isResizeObserverNoise(event?.message)) {
    event.stopImmediatePropagation();
  }
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <AuthInit>
          <PermissionProvider>
            <AppThemeProvider>
              <SidebarRailProvider>
                <App />
                <QuickNotesDock />
                <ToastContainer position="top-right" autoClose={3000} />
              </SidebarRailProvider>
            </AppThemeProvider>
          </PermissionProvider>
        </AuthInit>
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
);
